export default __webpack_public_path__ + "static/media/white geofence.63c5c5fe.svg";